import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import Contact from './pages/Contact';
import BarangayProfile from './pages/BarangayProfile';
import NotFound from './pages/NotFound';
import TermsAndConditions from './pages/TermsAndConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import DeleteAccount from './pages/DeleteAccount';

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Hide preloader after component mounts
    const timer = setTimeout(() => {
      setLoading(false);
      // Add page-loaded class to body
      document.body.classList.add('page-loaded');
    }, 600);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <div className="nk-wrap">
        <Header />
        <main className="nk-pages">
          <Routes>
            {/* Static routes first - higher priority */}
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/delete-account" element={<DeleteAccount />} />

            {/* Dynamic barangay route - lower priority */}
            <Route path="/:slug" element={<BarangayProfile />} />

            {/* 404 catch-all */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        {/* Preloader */}
        {loading && (
          <div className="preloader"><span className="spinner spinner-round"></span></div>
        )}
      </div>
    </Router>
  );
}

export default App;
